import {VerbrauchsanalyseForm} from "../../verbrauchsanalyse/verbrauchsanalyse.form";

export class VerbrauchsanalyseHeizcheckForm extends VerbrauchsanalyseForm {
  /**
   * @inheritDoc
   */
  modus: string = 'hec';

  /**
   * @inheritDoc
   * @protected
   */
  protected groups = {
    'nutzungstyp': ['nutzungstyp'],
    'gebaeudetyp': ['gebaeudetyp'],
    'heizungstyp': ['heizungstyp'],

    'basisinformationen/1': ['gebaeude_denkmalschutz'],
    'basisinformationen/2': ['energietraeger_name'],
    'basisinformationen/3': ['gebaeudebaujahr'],
    'basisinformationen/4': ['postleitzahl', 'ort'],
    'basisinformationen/5': ['bewohneranzahl'],
    'basisinformationen/6': ['gebaeude_stockwerke'],

    'heizsystem/1': ['gebaeude_flaeche', 'wohnung_flaeche'],
    'heizsystem/2': ['anzahl_wohneinheiten'],
    'heizsystem/3': ['wohnung_etage', 'gebaeude_dachgeschoss_ausgebaut', 'wohnung_anzahl_aussenwaende'],
    'heizsystem/4': ['keller_status'],
    'heizsystem/5': ['warmwasser_bereitungsart'],
    'heizsystem/6': ['warmwasser_messung'],
    'heizsystem/7': ['zusatzheizung_vorhanden'],
    'heizsystem/8': ['zusatzheizung_energietraeger'],
    'heizsystem/9': ['solarthermie_art'],

    'verbrauchsdaten': ['abrechnungszeitraum', 'energietraeger_verbrauch', 'energietraeger_kosten', 'heizkosten_gesamt', 'warmwasser_verbrauch_bekannt', 'warmwasser_verbrauch', 'warmwasser_temperatur', 'zusatzheizung_verbrauch_bekannt', 'zusatzheizung_verbrauch', 'zusatzheizung_kosten']
  };
}
